var data = {
    illustrations: [
      { type:"illustration",
        name: "illustration1",
        title: "No more whispers",
        field: ["Digital art"],
        role: ["Illustration"],
        date: "2013",
        thumbnail: "images/projects/project_01_desaturated.jpg"
      },
      {
        type:"illustration",
        name: "illustration2",
        title: "RunRunRun",
        field: ["Illustration"],
        role: ["Illustration"],
        date: "2012",
        thumbnail: "images/projects/runrunrun.jpg"
      },
      {
        type:"illustration",
        name: "illustration3",
        title: "Portraits",
        field: ["Illustration"],
        role: ["Illustration"],
        date: "2013",
        thumbnail: "images/projects/portraits.jpg"
      },
      {
        type:"illustration",
        name: "illustration4",
        title: "Everything Turns Gray",
        field: ["Illustration"],
        role: ["Illustration"],
        date: "2013",
        thumbnail: "images/projects/turnsgray.jpg"
      },
      {
        type:"illustration",
        name: "illustration5",
        title: "Natland Music Band",
        field: ["Illustration"],
        role: ["Illustration"],
        date: "2012",
        thumbnail: "images/projects/natland.jpg"
      },
      {
        name: "illustration6",
        title: "Wingless Symptoms",
        field: ["Illustration"],
        role: ["Illustration"],
        date: "2012",
        thumbnail: "images/projects/faza.jpg"
      },
      {
        type:"illustration",
        name: "illustration7",
        title: "Sketches",
        field: ["Illustration"],
        role: ["Illustration"],
        date: "2013",
        thumbnail: "images/projects/sketchs-1.jpg"
      },
      {
        type:"illustration",
        name: "illustration8",
        title: "Through a dog's eye",
        field: ["Illustration"],
        role: ["Illustration"],
        date: "2012",
        thumbnail: "images/projects/convers.jpg"
      },
    ],
    graphics: [
      {
        type:"graphic",
        name: "graphic1",
        title: "QA icons",
        field: ["Icon Design"],
        role: ["Graphic Design", "Vector Illustration"],
        date: "2015 - 2016",
        thumbnail: "images/projects/qaicons.jpg"
      },
      {
        type:"graphic",
        name: "hse",
        title: "Hot Spring Enthusiasts",
        field: ["Icon Design"],
        role: ["Logo Design", "UX/UI Design"],
        date: "2016",
        thumbnail: "images/projects/hse.jpg"
      },
      {
        type:"graphic",
        name: "vipp",
        title: "VIPP",
        field: ["UX/UI Design"],
        role: ["UX/UI Design"],
        date: "2015",
        thumbnail: "images/projects/vipp.gif"
      },
      {
        type:"graphic",
        name: "cmc",
        title: "Coming home café",
        field: ["UX/UI Design"],
        role: ["UX/UI Design"],
        date: "2016",
        thumbnail: "images/projects/cominghomecafe.jpg"
      },
      {
        type:"graphic",
        name: "graphic5",
        title: "Openwire",
        field: ["Openwire exhibition Poster"],
        role: ["Graphic Design", "Illustration"],
        date: "2014",
        thumbnail: "images/projects/openwireposter.jpg"
      },
      {
        type:"graphic",
        name: "graphic6",
        title: "Openwire",
        field: ["UX/UI Design"],
        role: ["Concept", "UX/UI Design"],
        date: "2014",
        thumbnail: "images/projects/openwire.gif"
      },
      {
        type:"graphic",
        name: "graphic7",
        title: "ValoTV - Dome of Visions",
        field: ["Poster design"],
        role: ["Graphic Design", "Illustration"],
        date: "2014",
        thumbnail: "images/projects/domeofvisions.jpg"
      },
      {
        type:"graphic",
        name: "graphic8",
        title: "Nordic Animals T-shirt Contest",
        field: ["Social media Cover photo"],
        role: ["Concept", "Graphic Design", "Illustration"],
        date: "2014",
        thumbnail: "images/projects/nordic.jpg"
      }
    ],
  
    websites: [
      {
        type:"website",
        name: "payapay",
        title: "payapay",
        description:"I've founded this website (which is still in development process), in order to facilitate the problem of Iranian abroad students receiving money from their family (while Iranian banks are under sanctions), and as I've struggled the same issue in the past, I came up with a solution as a web applciation. You can read more about the concept in the website's link.",
        field: ["Fullstack Development"],
        role: ["Concept Development", "Fullstack Development", "UI/UX design"],
        date: "2018",
        thumbnail: "images/projects/payapay.jpg"
      },
      {
        type:"website",
        name: "qator",
        title: "QAtor A/S",
        description: "One of my tasks in QAtor as a front-end developer was to build their own CMS website on Wordpress as well as graphic design and illustration of the informatics inside the website.",
        field: ["Website"],
        role: ["Graphic Design", "Web Development"],
        date: "2015 - 2016",
        thumbnail: "images/projects/qator.jpg"
      },
      // {
      //   name: "website2",
      //   title: "Main Deli Steakhouse",
      //   field: ["Website"],
      //   role: ["Graphic Design", "Web Development"],
      //   date: "2016",
      //   thumbnail: "images/projects/maindeli.jpg"
      // },
      {
        type:"website",
        name: "flip",
        title: "Flip Skateboard",
        description:"This is one of my first website project done in Adobe Flash, when creation of the whole front-end in Flash was meaniningfull. I still keep it in my portfolio as I was very proud of it on that time.",
        field: ["Website"],
        role: ["Graphic Design", "Web Development"],
        date: "2009",
        thumbnail: "images/projects/flipskate.jpg"
      },
      // {
      //   name: "website4",
      //   title: "Onkel Dannys",
      //   field: ["Website"],
      //   role: ["Graphic Design", "Web Development"],
      //   date: "2015",
      //   thumbnail: "images/projects/onkeldannys.jpg"
      // },
      {
        type:"website",
        name: "pendant",
        title: "Café Pendant",
        description:"Similar to Flip Skateboard project, this site was entirely made by Flash. It was almost around the time that HTML5 was becoming powerfull enough to replace most of the animation features supported by Flash. I still like to keep it in my portfolio as these old projects are so valuable for me.",
        field: ["Website"],
        role: ["Graphic Design", "Web Development"],
        date: "2011",
        thumbnail: "images/projects/pendant.jpg"
      }
    ],
  
    videos: [
      {
        type:"video",
        name: "video1",
        title: "Mia Nyegaard",
        field: ["Video"],
        role: ["Direction", "Motion Graphics", "Video Editing"],
        date: "2013",
        thumbnail: "images/projects/mia.jpg"
      },
      {
        type:"video",
        name: "video2",
        title: "Zibat Talks",
        field: ["Video"],
        role: ["Direction", "Motion Graphics", "Video Editing"],
        date: "2013",
        thumbnail: "images/projects/zibat.jpg"
      },
      {
        type:"video",
        name: "video3",
        title: "Helsinki Design Week",
        field: ["Video"],
        role: ["Direction", "Motion Graphics", "Video Editing"],
        date: "2014",
        thumbnail: "images/projects/designweek.jpg"
      }
    ],
  
    concepts: [
      // {
      //   name: "concept1",
      //   title: "SOUNDBIB",
      //   field: ["Concept Development"],
      //   role: ["Concept Development"],
      //   date: "2013",
      //   thumbnail: "images/projects/soundbib.jpg"
      // },
      {
        type:"concept" ,
        name: "drawingrobots",
        title: "Drawing Robots",
        description:"This project was done in collaboration with 3 other people: Tue Brisson Mosich, Hjalte Schurmann Illeborg and Rasmus Kudsk Nygreen. You can read more detail on the project, on the project's page.",
        field: ["Performance Design"],
        role: ["Performance Design", "Robotics","Arduino"],
        date: "2017",
        thumbnail: "images/projects/drawingrobots.jpg"
      },
      {
        type:"concept",
        name: "astronautescape",
        title: "Astronaut Escape",
        field: ["Android Game Development"],
        role: ["Android Development", "Illustration"],
        date: "2017",
        thumbnail: "images/projects/astronautescape.jpg"
      },
      {
        type:"concept",
        name: "game",
        title: "Arash Games",
        description:"In this casual project I store my random entertainment ideas as a prototype that can potentaily further developed at some point. I made it in a 8bit theme just to make it look more cool.",
        field: ["JavaScript Game Development"],
        role: ["Concept", "Gamification", "Development"],
        date: "2015",
        thumbnail: "images/projects/arashgames.jpg"
      }
    ]
  };

  export default data;